import React from 'react';
import LegalDocument from '../components/common/LegalDocument';

const PrivacyPolicy: React.FC = () => {
  return (
    <LegalDocument
      title="Privacy Policy"
      lastUpdated="March 20, 2024"
    >
      <h2>1. Information We Collect</h2>
      <p>We collect several types of information for various purposes:</p>
      <h3>1.1 Personal Information</h3>
      <ul>
        <li>Account information (name, email address, password)</li>
        <li>Profile information (profile picture, bio)</li>
        <li>Payment information (processed through secure payment providers)</li>
        <li>Usage data and preferences</li>
        <li>Communication records with our support team</li>
      </ul>

      <h3>1.2 Automatically Collected Information</h3>
      <ul>
        <li>Device information (IP address, browser type, device type)</li>
        <li>Log data (access times, pages viewed, error logs)</li>
        <li>Location information (country and region)</li>
        <li>Cookie data and similar tracking technologies</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>We use collected information for the following purposes:</p>
      <ul>
        <li>Providing and maintaining our services</li>
        <li>Processing your transactions and subscriptions</li>
        <li>Sending administrative information and updates</li>
        <li>Providing customer support and responding to inquiries</li>
        <li>Improving our services and user experience</li>
        <li>Detecting and preventing fraud or abuse</li>
        <li>Complying with legal obligations</li>
      </ul>

      <h2>3. Information Sharing and Disclosure</h2>
      <p>We may share your information with:</p>
      <ul>
        <li>Service providers (hosting, analytics, payment processing)</li>
        <li>Business partners (with your consent)</li>
        <li>Legal authorities when required by law</li>
        <li>Third parties in connection with a business transaction</li>
      </ul>

      <h2>4. Data Security</h2>
      <p>
        We implement appropriate security measures to protect your information, including:
      </p>
      <ul>
        <li>Encryption of data in transit and at rest</li>
        <li>Regular security assessments and audits</li>
        <li>Access controls and authentication requirements</li>
        <li>Secure data backup and recovery procedures</li>
      </ul>

      <h2>5. Your Data Rights</h2>
      <p>You have the right to:</p>
      <ul>
        <li>Access your personal information</li>
        <li>Correct inaccurate or incomplete data</li>
        <li>Request deletion of your data</li>
        <li>Object to or restrict processing</li>
        <li>Export your data in a portable format</li>
        <li>Withdraw consent at any time</li>
      </ul>

      <h2>6. Cookie Policy</h2>
      <p>
        We use cookies and similar tracking technologies to track activity and retain certain 
        information. You can instruct your browser to refuse all cookies or to indicate when 
        a cookie is being sent.
      </p>

      <h2>7. Age Restrictions</h2>
      <p>
        XTEA's services are strictly intended for users who are 18 years of age or older. 
        We do not knowingly collect or solicit personal information from anyone under the 
        age of 18. By using our services, you represent and warrant that you are at least 
        18 years old.
      </p>
      <p>
        If we discover that we have collected personal information from an individual under 
        18, we will promptly:
      </p>
      <ul>
        <li>Delete that information from our servers</li>
        <li>Terminate the associated account</li>
        <li>Take reasonable measures to ensure the user cannot re-register</li>
      </ul>
      <p>
        If you believe that we might have any information from or about a person under 18, 
        please contact us immediately at privacy@xtea.app.
      </p>

      <h2>8. International Data Transfers</h2>
      <p>
        Your information may be transferred to and processed in countries other than your 
        country of residence. We ensure appropriate safeguards are in place for such transfers.
      </p>

      <h2>9. Data Retention</h2>
      <p>
        We retain personal information for as long as necessary to provide our services and 
        fulfill the purposes outlined in this policy. When we no longer need personal 
        information, we securely delete or anonymize it.
      </p>

      <h2>10. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. We will notify you of any changes 
        by posting the new Privacy Policy on this page and updating the "Last Updated" date.
      </p>

      <h2>11. Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, please contact us at:
      </p>
      <p>
        Email: privacy@xtea.app<br />
        Address: [Your Company Address]<br />
        Phone: [Your Company Phone]
      </p>

      <h2>12. Legal Basis for Processing</h2>
      <p>
        We process personal information on the following legal bases:
      </p>
      <ul>
        <li>Performance of a contract with you</li>
        <li>Your consent</li>
        <li>Our legitimate business interests</li>
        <li>Compliance with legal obligations</li>
      </ul>
    </LegalDocument>
  );
};

export default PrivacyPolicy; 